"use client";
import React, { useState } from "react";

const UygunTurFormu = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [month, setMonth] = useState("");

  return (
    <div style={{ backgroundColor: "#f0f4ff", padding: "60px 20px" }}>
      <div style={{ maxWidth: "800px", margin: "auto", textAlign: "center" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "bold", color: "#272B59", marginBottom: "30px" }}>
          Hangi Tura Uygun Olduğunuzu Birlikte Belirleyelim
        </h2>

        <form
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <input
            type="text"
            placeholder="Ad Soyad"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={inputStyle}
          />
          <input
            type="tel"
            placeholder="0501 000 00 00"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={inputStyle}
          />
          <select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            style={{ ...inputStyle, cursor: "pointer" }}
          >
            <option value="">Planlanan Ay</option>
            {["Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"].map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          <div style={{ flexBasis: "100%", marginTop: "10px", textAlign: "left" }}>
            <label style={{ fontSize: "14px", color: "#444" }}>
              <input type="checkbox" required style={{ marginRight: "8px" }} />
              {/* <a href="#" style={{ color: "#3b5bd8", textDecoration: "underline" }}>
                Hisar Turizm KVKK Politikası’nı
              </a>{" "} */}
              okudum ve kabul ediyorum.
            </label>
          </div>

          <button
            type="submit"
            style={{
              backgroundColor: "#f57c00",
              color: "white",
              padding: "12px 30px",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              marginTop: "20px",
              cursor: "pointer",
            }}
          >
            Gönder
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  flex: "1 1 250px",
  padding: "12px",
  fontSize: "15px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  backgroundColor: "#fff",
};

export default UygunTurFormu;
